import { Component, Input, OnDestroy } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { LatestSales } from '../../../../../@core/data/dashboard-data';


@Component({
  selector: 'ngx-latest-sales-card',
  styleUrls: ['./latest-sales-card.component.scss'],
  templateUrl: './latest-sales-card.component.html',
})
export class LatestSalesCardComponent implements OnDestroy {

  @Input() cardData: LatestSales;

  currentTheme: string;

  constructor(private themeService: NbThemeService) {
    this.themeService.getJsTheme()
      .subscribe(theme => {
        this.currentTheme = theme.name;
      });
  }

  trackByDate(_: any, item: { paymentDate: any; }) {
    return item.paymentDate;
  }

  ngOnDestroy() {
  }
}
